
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/lyzarska-strediska",
      function () {
        return require("private-next-pages/[region]/lyzarska-strediska.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/lyzarska-strediska"])
      });
    }
  